import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import { Button } from '@mui/material'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import BidIncrementManage from './BidIncrementManage'
import { useLocation } from 'react-router-dom'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

const BidIncrement = () => {
    const settingContext = useContext(SettingContext)
    const [isLoading, setIsLoading] = useState(true)
    const {
        bid_increments,
        getAllBidIncrements,
        deleteBidIncrement,
        responseStatus: responseStatusCommuncation,
    } = settingContext
    const { setAlert } = useContext(AlertContext)

    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [changeStatus, setChangeStatus] = React.useState(false)
    const [deleteId, setDeleteId] = React.useState(0)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            filters: true,
            orderby: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllBidIncrements(values)
        },
    })

    useEffect(() => {
        if (bid_increments) {
            setTableBody(
                bid_increments.records.length ? bid_increments.records : []
            )
        }
        setIsLoading(false)
        setDeleteId(0)
        setChangeStatus(false)
    }, [bid_increments])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        setDeleteId(0)
        setChangeStatus(false)
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllBidIncrements(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from ===
                    'CommunicationStaticPages' &&
                responseStatusCommuncation.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllBidIncrements(formik.values)
                setAlert(
                    responseStatusCommuncation.message,
                    responseStatusCommuncation.status
                )
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, secondaryClickID, type) => {
        if (type === 'delete') {
            setDeleteId(id)
            setChangeStatus(true)
        } else {
            toggleFullScreenPopup(true, 'edit', id)
        }
    }

    const deleteOnClick = () => {
        const id = deleteId
        if (typeof id !== 'undefined' && id != 0) {
            let formData = { id: id }
            deleteBidIncrement(formData)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })
        // if (edit) {
        actionPush.push({
            buttonType: 'delete',
            clickType: 'delete',
            onclick: onClickEdit,
            tooltipTitle: 'Delete',
        })
        // }
        return actionPush
    }

    const tableValues = [
        {
            field: 'from_amount',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'From Amount',
            filterable: true,
            filterField: 'from_amount',
        },
        {
            field: 'to_amount',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'To Amount',
            filterable: true,
            filterField: 'to_amount',
        },
        {
            field: 'increment',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Offer Increment',
            filterable: true,
            filterField: 'increment',
        },
        // {
        //     field: 'action',
        //     type: 'button',
        //     clickType: 'edit',
        //     onclick: onClickEdit,
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Action',
        //     deleteLink: true,
        //     deleteOnClick: deleteOnClick,
        // },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const searchInfo = [
        {
            label: 'Page',
            placeholder: 'Enter Page',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="bidIncrement_add_new"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Offer Increment Range
                    </Button>
                </div>
                {isLoading ? (
                    <div>Loading..</div>
                ) : (
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={bid_increments}
                        changeTableFunction={getAllBidIncrements}
                    />
                )}
            </div>
            <BidIncrementManage
                data={manage}
                function={toggleFullScreenPopup}
            />
            <CustomDialog
                title={'Delete this Bid Increment'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete this Bid Increment</h5>
                <div className="actionWrapper">
                    <Button id="cancel" onClick={() => changeChangeStatus()}>
                        Cancel
                    </Button>
                    <PrimaryButton id="confirm" onClick={() => deleteOnClick()}>
                        Delete
                    </PrimaryButton>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default BidIncrement
